import styled from 'styled-components';

export default styled.h3`
  text-align: center;
  padding: 1rem 1rem 0;
  margin: 0;
`;
